import { gql } from "apollo-boost"

export const getAccountsExport = gql`
  query getAccountsExport{
    AccountsExport {
      id
      email
      isActive
      isImplementer
      implementerName
      displayName
      rol
    }
  }
`